import { PRICES } from '../components/Signup/Prices';

export default function getPlanPrice(planType, billingFrequency, currency) {
  if (planType && billingFrequency && currency) {
    return PRICES[planType][billingFrequency][currency];
  }
  return null;
}



// WEBPACK FOOTER //
// ./library/app/utils/getPlanPrice.js